import Navbar from "../../components/Navbar"

const Header = () => {
    return (
        <header className="flex header">
            <div className="brand">
                Jokes 4 days
            </div>
            <Navbar />
        </header>
    )
}

export default Header
